import React, { useState } from 'react';
import { PiHandWavingLight } from 'react-icons/pi';
import { BsCurrencyDollar } from 'react-icons/bs';
import { SalesTable } from 'src/types/model';
import { useNavigate } from 'react-router-dom';
import Button from '../button';
import { fetchOrderItems } from 'src/redux/action/orderItems.action';
import { useDispatch } from 'react-redux';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { fetchSales } from 'src/redux/action/sales.action';
import { Avatar, Menu, Modal as MUIModal, Skeleton } from '@mui/material';
import { DotsThree, X } from '@phosphor-icons/react/dist/ssr';
import { Modal } from 'src/components';
import { FiChevronDown } from 'react-icons/fi';
import newOrderImg from '../../assets/images/new_order.svg';

const Tables: React.FC<{
  loading: boolean;
  tables: SalesTable[];
}> = ({ loading, tables }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchOrderItems() as any);
  }, []);

  const [showTableModal, setShowTableModal] = useState<boolean[]>(
    tables?.map(() => false)
  );
  const [currentAction, setCurrentAction] = useState<any>(null);

  const handleOpenModal = (e: any, index: number) => {
    e.stopPropagation();
    const updatedModalStates = [...showTableModal];
    updatedModalStates[index] = true;
    setShowTableModal(updatedModalStates);
  };

  // Handler for closing the modal
  const handleCloseModal = (e: any, index: number) => {
    e.stopPropagation();
    const updatedModalStates = [...showTableModal];
    updatedModalStates[index] = false;
    setShowTableModal(updatedModalStates);
  };

  const [showCustomerActionModal, setCustomerActionModal] = useState<boolean[]>(
    tables?.map(() => false)
  );

  const handleOpenActionModal = (e: any, index: number, name: string) => {
    e.stopPropagation();
    const updatedModalStates = [...showCustomerActionModal];
    updatedModalStates[index] = true;
    setCustomerActionModal(updatedModalStates);
    setCurrentAction(name);
  };

  // Handler for closing the modal
  const handleCloseActionModal = (e: any, index: number) => {
    e.stopPropagation();
    const updatedModalStates = [...showCustomerActionModal];
    updatedModalStates[index] = false;
    setCustomerActionModal(updatedModalStates);
    setCurrentAction(null);
  };

  const handleTableEmpty = async (e: any, i: number) => {
    e.stopPropagation();
    const table = tables[i];
    const data = {
      id: table.id,
      newStatus: 'EMPTY',
    };
    handleCloseModal(e, i);
    try {
      await Service.post('/floors/tables/changeStatus', data);
      toastAlert('success', `Table emptied successfully`);
      dispatch(fetchSales() as any);
      handleCloseModal(e, i);
    } catch (err: any) {
      toastAlert('error', err.response?.data?.message);
      handleCloseModal(e, i);
    }
  };

  const handleTableAction = async (e: any, i: number) => {
    e.stopPropagation();
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '');
    const table = tables[i];
    const data = {
      id: table.id,
      action: currentAction,
    };
    handleCloseActionModal(e, i);
    try {
      await Service.post(
        '/floors/tables/notify/' + userInfo?.businessInfo?.id,
        data
      );
      dispatch(fetchSales() as any);
    } catch (err: any) {
      toastAlert('error', err.response?.data?.message);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedTable, setSelectedTable] = React.useState<any>(null);
  const [openMoveModal, setOpenMoveModal] = useState(false);
  const [filterFloors, setFilterFloors] = useState('');
  const open = Boolean(anchorEl);
  const handleDotClick = (event: any, table: any) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedTable(table);
  };
  const handleDotClose = (e: any) => {
    e.stopPropagation();
    setAnchorEl(null);
    setSelectedTable(null);
  };
  const handleMoveTable = (e: any) => {
    e.stopPropagation();
    setOpenMoveModal(true);
    setAnchorEl(null);
  };
  const Dotmenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleDotClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      PaperProps={{
        style: {
          boxShadow: 'none',
          width: '150px',
          marginTop: '10px',
          border: '1px solid #F1F0F6',
          height: 'fit-content',
          backgroundColor: '#FFFFFF',
          padding: '12px 24px',
          overflow: 'hidden',
        },
      }}
    >
      <div
        className={`font-Outfit text-center font-normal text-[16px] leading-6  text-warning cursor-pointer `}
        onClick={(e) => handleMoveTable(e)}
      >
        Move Table
      </div>
    </Menu>
  );
  const handleMoveTableAPI = async () => {
    try {
      if (filterFloors === '') toastAlert('error', 'Select a table');
      const data = {
        tableId: selectedTable?.id,
        moveToTableId: filterFloors,
      };
      await Service.post('/floors/tables/move', data);
      toastAlert('success', `Moved table`);
      setOpenMoveModal(false);
      setSelectedTable(null);
      dispatch(fetchSales() as any);
    } catch (err: any) {
      toastAlert('error', err.message);
    }
  };

  const MoveTableModal = () => (
    <>
      <MUIModal
        open={openMoveModal}
        onClick={(e: any) => {
          e.stopPropagation();
          setOpenMoveModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            padding: '16px 24px',
            borderRadius: 5,
            border: 'none',
            outline: 'none',
            backgroundColor: '#fff',
          }}
        >
          <div className="flex justify-between mb-3 items-center">
            <span className="text-2xl">Move table {selectedTable?.name}</span>
            <X
              size={24}
              onClick={(e: any) => {
                e.stopPropagation();
                setOpenMoveModal(false);
              }}
            />
          </div>
          <div
            className="flex flex-col gap-3"
            onClick={(e: any) => e.stopPropagation()}
          >
            <div className="flex flex-col w-full">
              <div className="font-Outfit font-normal mb-2 leading-[18px] text-[#7F8397]">
                Move to
              </div>
              <div className="relative">
                <select
                  className="w-full h-[51px] rounded-xl border outline-none cursor-pointer
                      border-[#CACFE3] appearance-none px-[20px] font-Outfit font-normal text-xs"
                  value={filterFloors}
                  onChange={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    setFilterFloors(event.target.value);
                  }}
                >
                  <option value={''} disabled>
                    Select table
                  </option>
                  {tables?.map((floor: any) => (
                    <option key={floor.id} value={floor.id}>
                      {floor.name}
                    </option>
                  ))}
                </select>
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                  <FiChevronDown className="text-gray-400" />
                </div>
              </div>
            </div>
            <Button
              disabled={filterFloors === ''}
              text="Move"
              className="w-[150px] ml-auto"
              onClick={handleMoveTableAPI}
            />
          </div>
        </div>
      </MUIModal>
    </>
  );

  return (
    <div className="flex flex-wrap gap-[22px]  mt-4 ">
      {loading ? (
        <>
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
          <Skeleton
            animation="wave"
            width={120}
            height={120}
            variant="rounded"
            sx={{ borderRadius: '12px' }}
          />
        </>
      ) : tables?.length > 0 ? (
        <>
          {tables.map((table, i) => {
            const notOccupied = table?.occupancyStatus === 'EMPTY';
            const showHoverClass = notOccupied ? '' : 'group-hover:flex';
            return (
              <div
                key={i}
                className={`relative group hover:shadow-xl min-w-[120px] max-w-[120px] px-3 table-overlay 
                  border border-solid border-light-gray
                  max-h-[120px] rounded-xl flex flex-col justify-center items-center gap-2 ${
                    table?.occupancyStatus === 'EMPTY'
                      ? 'bg-[#F1F0F6]'
                      : 'bg-[#D9E0FF]'
                  }
                cursor-pointer
                `}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/table', {
                    state: {
                      table: table,
                      type: 'dine_in',
                      fetchTable: true,
                      isEmpty: table?.occupancyStatus === 'EMPTY',
                    },
                  });
                }}
              >
                {table.hasNewOrder && (
                  <div className="table-overlay-circle flex justify-center items-center fade-in-out-to-lower-right">
                    <Avatar src={newOrderImg} />
                    <div className="table-overlay-in" />
                  </div>
                )}
                <div
                  className={`hidden ${showHoverClass} absolute top-2 right-2`}
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={(e) => handleDotClick(e, table)}
                >
                  <DotsThree size={24} />
                </div>
                {Dotmenu()}
                <p className="text-[16px] w-[100px] h-[42px] overflow-hidden  font-semibold leading-10 text-center font-Sarabun ">
                  {table?.name}
                </p>
                <p className="text-[16px] h-[21px] font-medium leading-10 text-center font-Sarabun flex items-center">
                  {table?.occupancy} pax
                </p>
                <p
                  className={`min-w-[80px] bg-pure-white rounded-[25px] text-[12px] font-semibold leading-[18px] text-center font-Outfit uppercase px-2 text-[#4062FF] ${
                    table?.occupancyStatus !== 'EMPTY'
                      ? 'text-[#4062FF]'
                      : 'text-[#949CC0]'
                  }`}
                  onClick={(e) => {
                    if (
                      table?.occupancyStatus === 'COMPLETE' ||
                      table?.occupancyStatus === 'OCCUPIED'
                    ) {
                      handleOpenModal(e, i);
                    }
                  }}
                >
                  {table?.occupancyStatus}
                </p>

                {table?.hasNotifiedWaiter && (
                  <div
                    className={`absolute top-[-2px] right-[-2px] w-8 h-8 rounded-full flex items-center justify-center bg-[#4062FF]`}
                    onClick={(e) => {
                      const name = 'notify';
                      handleOpenActionModal(e, i, name);
                    }}
                  >
                    <PiHandWavingLight
                      style={{ color: '#FFFFFF', fontSize: '20px' }}
                    />
                  </div>
                )}
                {table?.isReadyToPay && (
                  <div
                    className={`absolute top-[-8px] ${
                      table?.hasNotifiedWaiter || !table?.hasNotifiedWaiter
                        ? 'right-[-8px]'
                        : 'right-[20px]'
                    } w-8 h-8 rounded-full flex items-center justify-center bg-[#0BC988]`}
                    onClick={(e) => {
                      const name = 'ready_to_pay';
                      e.preventDefault();
                      handleOpenActionModal(e, i, name);
                    }}
                  >
                    <BsCurrencyDollar
                      style={{ color: '#FFFFFF', fontSize: '22px' }}
                    />
                  </div>
                )}
                {showCustomerActionModal[i] && (
                  <Modal
                    title="Resolve customer action?"
                    onClick={(e: any) => handleCloseActionModal(e, i)}
                    modalSize="30"
                  >
                    <div className="mx-5 mt-8">
                      <div className="flex flex-row justify-end gap-6 items-center w-full">
                        <div
                          className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                          onClick={(e) => handleCloseActionModal(e, i)}
                        >
                          Cancel
                        </div>
                        <button
                          className="bg-primary text-pure-white w-[150px] h-[41px] flex justify-center items-center font-Outfit font-semibold text-sm rounded-lg"
                          type="submit"
                          onClick={(e: any) => {
                            handleTableAction(e, i);
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </Modal>
                )}
                {showTableModal[i] && (
                  <Modal
                    title="Mark table as empty?"
                    onClick={(e: any) => handleCloseModal(e, i)}
                    modalSize="30"
                  >
                    <div className="mx-5 mt-8">
                      <div className="flex flex-row justify-end gap-6 items-center w-full">
                        <div
                          className="font-Sarabun font-semibold text-base text-primary cursor-pointer"
                          onClick={(e) => handleCloseModal(e, i)}
                        >
                          Cancel
                        </div>
                        <button
                          className="bg-primary text-pure-white w-[150px] h-[41px] flex justify-center items-center font-Outfit font-semibold text-sm rounded-lg"
                          type="submit"
                          onClick={(e: any) => {
                            handleTableEmpty(e, i);
                          }}
                        >
                          Mark Empty
                        </button>
                      </div>
                    </div>
                  </Modal>
                )}
              </div>
            );
          })}
        </>
      ) : (
        <div>No tables found</div>
      )}
      {MoveTableModal()}
    </div>
  );
};

export default Tables;
